module.exports = __webpack_public_path__ + "img/icons_30.5ee03f1d.svg";